/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./index.less");

var _tool = require("../../../../utils/tool");

var _config = require("../../../../utils/config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)("div", {
    className: "charge-tit"
}, void 0, "\u5B9E\u65F6\u6570\u636E111\uFF1A");

var _ref2 = (0, _jsx3.default)("div", {
    className: "charge-tit"
}, void 0, "\u6781\u503C\u6570\u636E\uFF1A");

var _ref3 = (0, _jsx3.default)("div", {
    className: "equipment-fault-tit"
}, void 0, "\u6545\u969C\u4FE1\u606F");

var _ref4 = (0, _jsx3.default)("tr", {
    className: "equipment-fault-header"
}, void 0, (0, _jsx3.default)("td", {}, void 0, "\u5E8F\u53F7"), (0, _jsx3.default)("td", {}, void 0, "\u6545\u969C"), (0, _jsx3.default)("td", {}, void 0, "\u72B6\u6001"));

var Bat = function (_Component) {
    (0, _inherits3.default)(Bat, _Component);

    function Bat(props, state) {
        (0, _classCallCheck3.default)(this, Bat);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Bat.__proto__ || (0, _getPrototypeOf2.default)(Bat)).call(this, props, state));

        _this.state = {
            real: [{ pat: "电池资产编号", val: "", key: 'batteryAssetCode' }, { pat: "电池生产厂商", val: "", key: 'batteryManufacturer' }, { pat: "电池类型", val: "", key: 'batteryTypeNumber' }, { pat: "荷电状态SOC", val: "", key: 'soc' }, { pat: "预估剩余充电时间(min)", val: "", key: 'remainChargingTime' }, { pat: "累计充电次数", val: "", key: 'totalChargedTimes' }, { pat: "电池版本号", val: "", key: 'batteryVersion' }, { pat: "蓄电池额定容量(Ah)", val: "", key: 'batteryRatedCapacity' }, { pat: "蓄电池额定总电压(v)", val: "", key: 'batteryRatedTotalVoltage' }, { pat: "动力蓄电池标称总能量(kwh)", val: "", key: 'powerBatteryNominalTotalEnergy' }, { pat: "电池组当前总电压(v)", val: "", key: 'presentBatteryPackTotalVoltage' }, { pat: "最高单体电压(v)", val: "", key: 'singleHighestVoltage' }, { pat: "最高单体电压编号", val: "", key: 'singleHighestVoltageNum' }, { pat: "最低单体电压(v)", val: "", key: 'singleLowestVoltage' }, { pat: "最低单体电压编号", val: "", key: 'singleLowestVoltageNum' }, { pat: "电池组最高温度(℃)", val: "", key: 'batteryPackHighestTemperature' }, { pat: "最高温度探头编号", val: "", key: 'highestTemperatureProbeNum' }, { pat: "电池组最低温度(℃)", val: "", key: 'batteryPackLowestTemperature' }, { pat: "最低温度探头编号", val: "", key: 'lowestTemperatureProbeNum' }],
            extremum: [{ pat: "最高允许充电总电压(v)", val: "", key: 'maxAllowChargingTotalVoltage' }, { pat: "最高允许温度(℃)", val: "", key: 'maxAllowTemperature' }, { pat: "单体电池最高允许充电电压(v)", val: "", key: 'singleBatteryAllowedChargingVoltage' }],
            secondarys: []
        };
        return _this;
    }
    /*2019.8.22*/


    (0, _createClass3.default)(Bat, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.handleGetList();
            this.handleFault();
        }
    }, {
        key: "handleGetList",
        value: function handleGetList() {
            var _this2 = this;

            var param = {
                deviceId: this.props.deviceId,
                batteryCabinetNum: this.props.batteryCabinetNum
            };
            (0, _tool.http)(_config.apiJson.getCabinetBmsInfo, param || {}).then(function (res) {
                res.batteryVersion = res.batteryVersion2 && res.batteryVersion1 ? 'v' + res.batteryVersion2 + (res.batteryVersion1 > 10 ? '.' : '.0.') + res.batteryVersion1 : '--';
                var result = res || {};
                _this2.state.real.forEach(function (item) {
                    if (item.pat.indexOf('v') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else if (item.pat.indexOf('Ah') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else if (item.pat.indexOf('A') !== -1) {
                        item.val = result[item.key] / 100 || '--';
                    } else if (item.pat.indexOf('kwh') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else {
                        item.val = result[item.key] || result[item.key] == 0 ? result[item.key] : '--';
                    }
                });
                _this2.state.extremum.forEach(function (item) {
                    if (item.pat.indexOf('v') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else if (item.pat.indexOf('Ah') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else if (item.pat.indexOf('A') !== -1) {
                        item.val = result[item.key] / 100 || '--';
                    } else if (item.pat.indexOf('kwh') !== -1) {
                        item.val = result[item.key] / 10 || '--';
                    } else {
                        item.val = result[item.key] || result[item.key] == 0 ? result[item.key] : '--';
                    }
                });
                _this2.setState({
                    real: _this2.state.real,
                    extremum: _this2.state.extremum
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
                message.error(msg);
            });
        }
        // 故障列表

    }, {
        key: "handleFault",
        value: function handleFault() {
            var _this3 = this;

            var param = {
                deviceId: this.props.deviceId,
                batteryCabinetNum: this.props.batteryCabinetNum
            };
            (0, _tool.http)(_config.apiJson.getCabinetBmsFaultInfo, param || {}).then(function (res) {
                _this3.setState({
                    secondarys: res || []
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
                message.error(msg);
            });
        }
        /*------------------------------*/

    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                _state$real = _state.real,
                real = _state$real === undefined ? [] : _state$real,
                _state$extremum = _state.extremum,
                extremum = _state$extremum === undefined ? [] : _state$extremum,
                secondarys = _state.secondarys;

            return (0, _jsx3.default)("div", {
                className: "bat"
            }, void 0, (0, _jsx3.default)("div", {
                className: "charge-realtime"
            }, void 0, _ref, (0, _jsx3.default)("div", {
                className: "charge-datas"
            }, void 0, real.map(function (res, i) {
                if (res.key == 'batteryVersion') {
                    if (_this4.props.deviceType === '332' || _this4.props.deviceType === '335') {
                        return (0, _jsx3.default)("div", {
                            className: "charge-xx"
                        }, i, res.pat, "\uFF1A", res.val);
                    }
                } else {
                    return (0, _jsx3.default)("div", {
                        className: "charge-xx"
                    }, i, res.pat, "\uFF1A", res.val);
                }
            }))), (0, _jsx3.default)("div", {
                className: "charge-realtime"
            }, void 0, _ref2, (0, _jsx3.default)("div", {
                className: "charge-datas"
            }, void 0, extremum.map(function (res, i) {
                return (0, _jsx3.default)("div", {
                    className: "charge-xx"
                }, i, res.pat, "\uFF1A", res.val);
            }))), (0, _jsx3.default)("div", {
                className: "equipment-fault"
            }, void 0, _ref3, (0, _jsx3.default)("table", {
                className: "equipment-fault-info",
                style: { width: "33%" }
            }, void 0, _ref4, secondarys.map(function (res, i) {
                return (0, _jsx3.default)("tr", {
                    className: "equipment-fault-footer"
                }, i, (0, _jsx3.default)("td", {}, void 0, i + 1, ". "), (0, _jsx3.default)("td", {}, void 0, _tool.filter.faultInfo(res.function), " "), (0, _jsx3.default)("td", {}, void 0, res.status === 0 ? '正常' : '异常'));
            }))));
        }
    }]);
    return Bat;
}(_react.Component);

exports.default = Bat;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/sbDevice/batteryInfo/bat/index.jsx
// module id = 1556
// module chunks = 0